import { Form, Input, Button, Col, notification, Modal } from "antd";
import React, { useEffect } from "react";
import { sendEmail } from "../../services/appServices";
import { strings } from "../../utils/strings";

export default function FormHelp({ data, visible, onClose }) {
  const [form] = Form.useForm()
  const _onCancel = () => {
    form.resetFields();
    onClose();
  };

  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };

  const validateMessages = {
    required: "${label} es un campo requerido!",
    types: {
      email: "${label} no es válido!",
      number: "${label} no es válido!",
    },
  };

  const openNotification = () => {
    notification["success"]({
      message: "¡Excelente!",
      description: "El correo ha sido enviado con éxito",
    });
  };

  const openNotificationError = () => {
    notification["error"]({
      message: "¡Ups!",
      description: "Algo salió mal, no hemos podido enviar tu correo",
    });
  };

  const onFinish = async (values) => {
    try {
      const params = {
        ...values,
        destination: data.emailsAdmin.split(","),
        of: data.sendEmail,
      };
      const response = await sendEmail(params);
      if (response && response.MessageId) {
        openNotification();
        form.resetFields();
        _onCancel();
      }
    } catch (error) {
      console.log(error.message);
      openNotificationError();
    }
  };

  useEffect(() => {
    form.resetFields()
  }, []);
  return (
    <>
      <Modal
        title="Ayuda"
        visible={visible}
        onCancel={_onCancel}
        wrapClassName="ant-modal-default"
        footer=""
      >
        <div className="ant-modal-default-description">
          Déjanos tus datos para poder comunicarnos contigo a la mayor brevedad
          posible.
        </div>
        <Form
          {...layout}
          name="nest-messages"
          onFinish={onFinish}
          validateMessages={validateMessages}
          form={form}
        >
          <Form.Item
            name="fullname"
            label="Nombre"
            rules={[
              {
                required: true,
                message: "",
              },
              ({ getFieldValue }) => ({
                validator() {
                  if (
                    !getFieldValue("fullname") ||
                    !getFieldValue("fullname").toString().trim()
                  ) {
                    return Promise.reject(
                      new Error("¡${label} es un campo requerido!")
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input data-testid="input-fullname" />
          </Form.Item>
          <Form.Item
            name="mobile"
            label="Celular"
            rules={[
              { required: true, message: "" },
              ({ getFieldValue }) => ({
                validator() {
                  if (
                    !getFieldValue("mobile") ||
                    !getFieldValue("mobile").toString().trim()
                  ) {
                    return Promise.reject(
                      new Error("¡${label} es un campo requerido!")
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input
              style={{ width: "100%" }}
              data-testid="input-celular"
              type="number"
              onKeyDown={(e) => {
                if (/[^a-z^A-Z^\s]|[A-Za-z]{2,}/.test(e.key)) {
                  return true;
                }
                e.preventDefault();
                return false;
              }}
            />
          </Form.Item>
          <Form.Item
            name="email"
            label="Correo"
            rules={[
              {
                required: true,
                message: "",
              },
              {
                type: "email",
                message: `${strings["rule-email"].message}`,
              },
              ({ getFieldValue }) => ({
                validator() {
                  if (
                    !getFieldValue("email") ||
                    !getFieldValue("email").toString().trim()
                  ) {
                    return Promise.reject(
                      new Error("¡${label} es un campo requerido!")
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input data-testid="input-email" />
          </Form.Item>
          <Form.Item
            name="message"
            label="Descripción"
            rules={[
              { required: true, message: "" },
              ({ getFieldValue }) => ({
                validator() {
                  if (
                    !getFieldValue("message") ||
                    !getFieldValue("message").toString().trim()
                  ) {
                    return Promise.reject(
                      new Error("¡${label} es un campo requerido!")
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input.TextArea data-testid="input-descripcion"/>
          </Form.Item>
          <Col span={24}>
            <Form.Item className="actions help-align">
              <Button
                onClick={_onCancel}
                className="ant-btn-solid ant-btn-solid-transparent"
                data-testid='onclose-cancel'
              >
                Cancelar
              </Button>
              <Button
                className="ant-btn-solid ant-btn-solid-c1"
                htmlType="submit"
                data-testid="submit-click"
              >
                Enviar
              </Button>
            </Form.Item>
          </Col>
        </Form>
      </Modal>
    </>
  );
}
